define('StellarGrade.ST_NewsletterForm.NewsletterForm.Model', ['Backbone', 'Utils'], function (Backbone, Utils) {
    'use strict';

    return Backbone.Model.extend({
        
    });
});
